import React from "react";
import { GrantDto } from "../../../../dtos/GrantDto";
import { StepDto } from "../../../../dtos/StepDto";
import { useSubTaskCommentsController } from "./hooks/useSubTaskCommentsController";
import { SubTaskCommentsView } from "./components/SubTaskCommentsView";

interface ISubTaskCommentsProps {
    grantId: string;
    grant?: GrantDto | null;
    step: StepDto;
}

export default function SubTaskComments({ grantId, grant, step }: ISubTaskCommentsProps) {
    const ctrl = useSubTaskCommentsController({ grantId, grant, step });
    return <SubTaskCommentsView {...ctrl} />;
}
